import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';

import { toggleModal } from 'data/actions/modals';
import { removeSequenceSchedule } from 'data/actions/sequences';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';
import { Container } from '../deleteStep/styles';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const DeleteSequenceScheduleModal = () => {
  const dispatch = useDispatch();
  const { visible } = useSelector(modalsSelector);
  const { scheduleId } = useSelector(modalOptionsSelector);

  const handleClose = () => dispatch(toggleModal('delete_sequence_schedule', false));
  const handleDelete = () => {
    dispatch(removeSequenceSchedule(scheduleId));
    dispatch(toggleModal('delete_sequence_schedule', false));
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Delete schedule
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <Container>
        <div>You&#39;re about to delete the schedule. Deleted schedule can&#39;t be restored</div>
      </Container>
      <Footer>
        <Button data-form="true" type="danger" size="large" onClick={handleDelete}>
          Delete
        </Button>
        <Button size="large" type="default" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default DeleteSequenceScheduleModal;
